import { db } from '@/firebase/init';
import { collection } from 'firebase/firestore';
import { useMemo } from 'react';
import { useFirestoreCollection } from '../hooks/useFirestoreCollection';
import { LocalConnectorData } from '@/pages/Connectors/Connectors';

function useWorkspaceConnectors(workspaceId: string): LocalConnectorData[] {
  const query = useMemo(
    () => collection(db, `workspaces/${workspaceId}/connectors`),
    [workspaceId],
  );

  const rawConnectors = useFirestoreCollection<LocalConnectorData>(
    ['connectors', workspaceId],
    query,
  );

  return rawConnectors;
}

export { useWorkspaceConnectors };
